// @flow

import React, { Component } from 'react';
import $ from 'jquery';
import { FormControl } from 'react-bootstrap';

type Props = {
  onChange: Function,
  onBlur: Function,
  onFocus: Function,
  value: number,
  val: number
};

class Clock extends Component<Props> {
  props: Props;

  // componentWillReceiveProps(nextProps) {
  //   if (!nextProps.meta.active) {
  //     //nextProps.onBlur(this.$el[0].value);
  //   }
  // }

  shouldComponentUpdate(nextProps: Props) {
    if (nextProps.val !== this.props.val) {
      return true;
    }
    return false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.children !== this.props.children) {
      this.$el.triggerHandler('change');
    }
  }

  componentDidMount() {
    this.$el = $(this.el);
    this.$el.clockpicker({
      align: 'left',
      donetext: 'Done',
      autoclose: 'true',
      init: () => {
        this.$el.focus();
      },
      beforeDone: () => {
        this.$el.triggerHandler('blur');
      },
      afterDone: () => {
        this.$el.triggerHandler('blur');
      }
    });

    this.$el.on('change', this.handleChange);
    this.$el.on('blur', this.handleBlur);
    this.$el.on('focus', this.handleFocus);
    // this.$el.hide();
  }

  componentWillUnmount() {
    this.$el.off('change', this.handleChange);
    this.$el.off('blur', this.handleBlur);
    this.$el.off('focus', this.handleFocus);
    this.$el.clockpicker('remove');
  }
  handleOnClick = () => {
    this.$el.focus();
  };

  handleChange = e => {
    this.props.onChange(e);
  };

  handleBlur = e => {
    this.props.onBlur(e);
  };

  handleFocus = e => {
    this.props.onFocus(e);
  };

  render() {
    return (
      <div className="input-group clockpicker" onClick={this.handleOnClick}>
        <input
          type="text"
          className="form-control"
          readOnly="readOnly"
          value={this.props.val}
          ref={el => (this.el = el)}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          onKeyPress={this.props.onKeyPress}
        />
        <span className="input-group-addon">
          <span className="glyphicon glyphicon-time" />
        </span>
      </div>
    );
  }
}

type PropsTwo = {
  onChange: Function,
  onBlur: Function,
  onFocus: Function,
  value: number
};

type State = {
  val: number
};

export default class extends Component<PropsTwo, State> {
  props: PropsTwo;
  state: State;

  constructor(props: PropsTwo) {
    super(props);
    this.state = {
      val: this.props.value
    };
  }

  handleChange = (e: SyntheticKeyboardEvent<HTMLInputElement> & { target: HTMLInputElement }) => {
    this.setState({ val: e.target.value });
    this.props.onChange(e);
  };

  handleBlur = (e: SyntheticEvent<HTMLInputElement>) => {
    this.props.onBlur(e);
  };

  handleFocus = (e: SyntheticEvent<HTMLInputElement>) => {
    this.props.onFocus(e);
  };

  render() {
    return (
      <FormControl
        componentClass={Clock}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        val={this.state.val}
        meta={this.props.meta}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ClockPicker/index.js